import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { store, persistor } from './store'
import { Provider } from 'react-redux'
import * as serviceWorker from './serviceWorker'
import { PersistGate } from 'redux-persist/lib/integration/react'
import { MantineProvider } from '@mantine/core'
import './i18n' // IMPORTANT: Initialiser i18next avant l'app
// Ligne supprimée : import { Notifications } ...

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <MantineProvider withGlobalStyles withNormalizeCSS>
        {/* Ligne supprimée : <Notifications /> */}
        <App />
      </MantineProvider>
    </PersistGate>
  </Provider>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()